import { render, staticRenderFns } from "./SingleFont.vue?vue&type=template&id=4293df7e"
import script from "./SingleFont.vue?vue&type=script&lang=js"
export * from "./SingleFont.vue?vue&type=script&lang=js"
import style0 from "./SingleFont.vue?vue&type=style&index=0&id=4293df7e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports